//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "InspectionRecordItemModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "巡检结果表单",
      tableName: "om_inspection_record_item",
      form_fields: ['recordId', 'pointId', 'itemId', 'val'],
      form_fields_time: [],
      validatorRules: {
        recordId: {
          rules: [{
            required: true,
            message: '请输入巡检记录!'
          }]
        },
        pointId: {
          rules: [{
            required: true,
            message: '请输入巡检点ID!'
          }]
        },
        itemId: {
          rules: [{
            required: true,
            message: '请输入巡检项目ID!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};